import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-flow-test',
  templateUrl: './flow-test.component.html',
  styleUrls: ['../../../snapshot/components/flows-status/flows-status.component.scss',
    '../../../snapshot/components/flows-status/flows-status-responsive.component.scss'
    , './flow-test.component.scss']
})
export class FlowTestComponent implements OnInit {

  @Input() selector_test;
  @Input() flow_version;

  constructor() { }

  ngOnInit() {
  }

}
